import { z } from "zod";

export const sandboxTokenBudgetDecisionSchema = z.enum([
  "sent",
  "compacted",
  "rejected",
]);

export const sandboxTokenBudgetReservesSchema = z.object({
  outputBudget: z.number().int().nonnegative(),
  toolReserve: z.number().int().nonnegative(),
  safetyMargin: z.number().int().nonnegative(),
});

export const sandboxTokenBudgetMetadataSchema = z.object({
  estimatedTokens: z.number().int().nonnegative(),
  estimatedRequestTokens: z.number().int().nonnegative(),
  estimatedTotalTokens: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  inputLimit: z.number().int().positive(),
  outputBudget: z.number().int().nonnegative(),
  toolReserve: z.number().int().nonnegative(),
  safetyMargin: z.number().int().nonnegative(),
  reserves: sandboxTokenBudgetReservesSchema,
  decision: sandboxTokenBudgetDecisionSchema,
  reason: z.string().trim().min(1),
  providerOutputCeiling: z.number().int().positive().optional(),
  costThreshold: z.number().int().positive().optional(),
  accountRequestCeiling: z.number().int().positive().optional(),
  compacted: z.boolean(),
  droppedMessageCount: z.number().int().nonnegative(),
  beforeEstimatedRequestTokens: z.number().int().nonnegative().optional(),
  beforeEstimatedTotalTokens: z.number().int().nonnegative().optional(),
  droppedToolCallReferences: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  retainedToolCallReferences: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
      }),
    )
    .optional(),
});

export type SandboxTokenBudgetDecision = z.infer<
  typeof sandboxTokenBudgetDecisionSchema
>;
export type SandboxTokenBudgetReserves = z.infer<
  typeof sandboxTokenBudgetReservesSchema
>;
export type SandboxTokenBudgetMetadata = z.infer<
  typeof sandboxTokenBudgetMetadataSchema
>;

export const SANDBOX_TOKEN_BUDGET_METADATA_KEY = "tokenBudget" as const;
export const SANDBOX_TOKEN_BUDGET_HISTORY_METADATA_KEY =
  "tokenBudgetRequests" as const;
